<div class="row  mt-3" *ngIf="!currentEmployee.pendingLoanRequests.pending; else showPending">
  <div class="col-md-12">

    <app-header headerText="Solicitud De Préstamo Caja De Ahorro Permanente:" [small]="true"></app-header>
    <div *ngIf="currentEmployee">

      <h5 class="mb-5">Datos del Jefe:</h5>

      <app-employee-ref [employeeRef]="currentEmployee.workInformation.supervisor"></app-employee-ref>

    </div>

    <h5 class="mb-5">Datos a Tomar en Cuenta para la Solicitud:</h5>

    <div class="row">

      <div class="col-md-4">
        <mat-form-field>
          <span class="matPrefixDisabled" mxatPrefix>$&nbsp;</span>
          <input matInput style="width:95%;" placeholder="Monto Máximo que puede solicitar:" [value]="(maxLoanAmount | number: '.2-2')" type="text" disabled>
        </mat-form-field>
      </div>

      <div class="col-md-4">
        <mat-form-field>
          <input matInput placeholder="Máximo de Cuotas para Descuento:" [value]="maxNumberOfPayments" type="number" disabled>
        </mat-form-field>
      </div>

      <div class="col-md-4">
        <mat-form-field>
          <input matInput style="width:95%;" placeholder="Factor de Interés:" [value]="loanInterest.toFixed(4)" type="text" disabled>
        </mat-form-field>
      </div>

    </div>

    <h5 class="my-5">Préstamo a Solicitar:</h5>

    <div class="row" onpaste="return false">

      <div class="col-md-4">
        <mat-form-field>
          <span matPrefix>$&nbsp;</span>
          <input matInput style="width:95%;" placeholder="Monto del Préstamo a solicitar:" [ngModel]="newLoan.requestedAmount | number: '1.'" (ngModelChange)="newLoan.requestedAmount=currencyInputChanged($event)" appOnlyNumber [allowDecimals]="true" type="text" type="string">
        </mat-form-field>
      </div>

      <div class="col-md-4">
        <mat-form-field>
          <input matInput placeholder="Número de Cuotas a Descontar de la Nómina:" [(ngModel)]="newLoan.requestedNumberOfPayments" type="number" min="0" onkeypress="return event.charCode >= 48 && event.charCode <= 57" type="number">
        </mat-form-field>
      </div>

      <div class="col-md-4 center-vertically">
        <button style="margin-bottom: 1.25em;" class="btn btn-block btn-primary" (click)="calculate()">Calcular Intereses</button>
      </div>

    </div>

    <div class="row">

      <div class="col-md-4">
        <mat-form-field>
          <span class="matPrefixDisabled" matPrefix>$&nbsp;</span>
          <input matInput placeholder="Intereses Generados:" [value]="(newLoan.interestAmount | number: '.2-2')" type="text" disabled>
        </mat-form-field>
      </div>

      <div class="col-md-4">
        <mat-form-field>
          <span class="matPrefixDisabled" matPrefix>$&nbsp;</span>
          <input matInput placeholder="Monto a Descontar {{textWage}}:" [value]="discountPerPayment ? (discountPerPayment | number: '.2-2') : '0'" type="text" disabled>
        </mat-form-field>
      </div>

    </div>

    <div class="mt-5 row" *ngIf="newLoan.scheduleDates.values().length > 0">
      <div class="col-md-12">

        <table mat-table *ngIf="!newLoanType" [dataSource]="newLoan.scheduleDates.values()" class="table border">

          <ng-container matColumnDef="depositDateBiWeek">
            <th mat-header-cell *matHeaderCellDef> Número De Catorcena: </th>
            <td mat-cell *matCellDef="let i = index"> {{i + 1}} </td>
          </ng-container>

          <ng-container matColumnDef="depositDateWeek">
            <th mat-header-cell *matHeaderCellDef> Número De Semana: </th>
            <td mat-cell *matCellDef="let i = index"> {{i + 1}} </td>
          </ng-container>

          <ng-container matColumnDef="totalAmount">
            <th mat-header-cell *matHeaderCellDef> Total: </th>
            <td mat-cell *matCellDef="let element"> {{element.capital | number: '.2-2'}} </td>
          </ng-container>

          <ng-container matColumnDef="paid">
            <th mat-header-cell *matHeaderCellDef> Pagado: </th>
            <td mat-cell *matCellDef="let element">
              <mat-icon>{{element.paid ? 'check' : 'alarm'}}</mat-icon>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedUpFrontColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedUpFrontColumns; let i = index"></tr>

        </table>

        <table mat-table *ngIf="newLoanType" [dataSource]="newLoan.scheduleDates.values()" class="table border">

          <!-- depositDate Column -->
          <ng-container matColumnDef="biWeekNumber">
            <th mat-header-cell *matHeaderCellDef> Número Catorcena </th>
            <td mat-cell *matCellDef="let element"> {{element.biWeekNumber}} </td>
          </ng-container>

          <!-- depositDate Column -->
          <ng-container matColumnDef="weekNumber">
            <th mat-header-cell *matHeaderCellDef> Número Semana </th>
            <td mat-cell *matCellDef="let element"> {{ element.weekNumber }} </td>
          </ng-container>

          <!-- depositDate Column -->
          <ng-container matColumnDef="year">
            <th mat-header-cell *matHeaderCellDef> Año </th>
            <td mat-cell *matCellDef="let element"> {{ element.depositDate | date:'yyyy'}} </td>
          </ng-container>

          <!-- capital Column -->
          <ng-container matColumnDef="capital">
            <th mat-header-cell *matHeaderCellDef> Capital </th>
            <td mat-cell *matCellDef="let element">$ {{element.capital | number: '.2-2'}} </td>
          </ng-container>

          <!-- totalAmount Column -->
          <ng-container matColumnDef="capitalAmortization">
            <th mat-header-cell *matHeaderCellDef> Capital Pendiente: </th>
            <td mat-cell *matCellDef="let element">$ {{element.capitalAmortization  | number: '.2-2'}} </td>
          </ng-container>

          <!-- totalAmount Column -->
          <ng-container matColumnDef="interest">
            <th mat-header-cell *matHeaderCellDef> Intereses: </th>
            <td mat-cell *matCellDef="let element">$ {{element.interest  | number: '.2-2'}} </td>
          </ng-container>

          <!-- totalAmount Column -->
          <ng-container matColumnDef="totalAmount">
            <th mat-header-cell *matHeaderCellDef> Total: </th>
            <td mat-cell *matCellDef="let element">$ {{element.total  | number: '.2-2'}} </td>
          </ng-container>

          <ng-container matColumnDef="paid">
            <th mat-header-cell *matHeaderCellDef> Pagado: </th>
            <td mat-cell *matCellDef="let element">
              <mat-icon>{{element.paid ? 'check' : 'alarm'}}</mat-icon>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedFixedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedFixedColumns; let i = index"></tr>

        </table>

      </div>
    </div>

    <div class="my-5 row">
      <div class="col-md-4 offset-md-4">
        <!-- TODO Mostrar confirmación antes de cancelar - REVISAR-->
        <button class="btn btn-outline-secondary btn-block" (click)="cancel(1, null)">Cancelar</button>
      </div>
      <div class="col-md-4">
        <!-- TODO Mostrar Confirmación - TERMINAR-->
        <button class="btn btn-block btn-primary" (click)="saveLoanRequest()">Aceptar</button>
      </div>
    </div>
  </div>
</div>

<ng-template #showPending>
  <div class="row mt-4 mb-4">
    <div class="col-md-12 text-center noActions">
      <h5 class="mt-1">Solicitud De Préstamo Caja De Ahorro Permanente</h5>
      <mat-icon aria-hidden="true">check</mat-icon>
      <h5>{{currentEmployee.pendingLoanRequests.pending}}</h5>
    </div>
  </div>
  <div class="my-5 row">
    <div class="col-md-4 offset-md-4">
      <button class="btn btn-outline-secondary btn-block" (click)="cancelSimple(1, null)">Regresar</button>
    </div>
  </div>
</ng-template>
